export const FORMS_PRICE = 199;
export const FORMS_DIGITIZATION_FEE = 200;
export const FORMS_PAGE_URL = '/forms/submissions/inbox/all';
export const FORMS_VIDEO_URL = 'https://fast.wistia.com/embed/medias/2mcdggqs2z';
